module.exports = __webpack_public_path__ + "img/arrow-left.dab94496.svg";